export const GoodsItem = {
    name:'',
    label: '',
    value:''
}
export const GoodsState = [

];

